import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import LocalizationStore from '../../../Stores/LocalizationStore'
import ReportsService from '../../../Services/ReportsService'
import { IReportModel } from '../../../Stores/ConfigStore'

export interface IReportsPageProps {
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class ReportsPage extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        const { localizationStore } = this.props

        return (
            <div className="reportsWrapper">
                <h5 className="reportsLabel">{localizationStore!.t('Reports')}</h5>
                <div className="listItems row">
                    {
                        ReportsService.getIframes().map((x: IReportModel) => {
                            return (
                                <div className="col-6" key={x.Key}>
                                    <NavLink className="listItem" to={`/Reports/${x.Key}/`}>
                                        {localizationStore!.t(x.Key)}
                                    </NavLink>
                                </div>
                            )
                        })
                    }

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Reports/ReportsPage.tsx